import { Component, inject, OnInit } from '@angular/core';
import { GenesisUnitOfWork } from 'app/core/core.module';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { Subject } from 'rxjs';

@Component({
    selector: 'app-bulk-edit-dialog',
    templateUrl: './bulk-edit-dialog.component.html',
    styleUrls: ['./bulk-edit-dialog.component.scss'],
    standalone: false,
})
export class BulkEditDialogComponent implements OnInit {
    result: Subject<any> = new Subject<any>();
    bulkInfo: any;
    vendors: any;
    isAssemblyOptions = ['True', 'False'];
    processing = false;

    modalRef = inject(BsModalRef);
    uow = inject(GenesisUnitOfWork);
    constructor() {}

    async ngOnInit() {
        this.vendors = await this.uow.getVendors();
    }

    async save() {
        this.processing = true;
        this.result.next({ success: true, value: this.bulkInfo });
    }

    close() {
        this.uow.rollback();
        this.result.next({ success: false });
    }
}
